/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.video.conference.component.rpc.ui.service.v1.WebinarsChirpUIService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import * as References from './WebinarsChirpUIService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.conference.component.rpc.ui.service.v1.WebinarsChirpUIService#getWebinars
 */
export const GET_WEBINARS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: 'getWebinars',
  args: ['appId', 'businessUnitId', 'selectedWebinarId', 'searchQuery', 'limit', 'nextCursor', 'eventStatus'],
  fetcher(request, ctx) {
    return chirpClient.call(References.getWebinarsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});